<template>
  <div class="loginBox">
    <div class="loginTitle">{{ $t('SystemName') }}</div>
    <div class="loginMain clearfix">
      <div class="loginLeft">
        <img src="../../assets/images/login/loginLeft.png" alt="" />
      </div>
      <form class="loginForm" action="/login" method="post">
        <div class="loginFormTitle">
          {{ $t('LoginModule.AdministratorLogin') }}
        </div>
        <p class="showMsg" v-show="showErrorMessage">{{ ErrorMessage }}</p>
        <div class="loginGroup">
          <div class="loginIcon">
            <img src="../../assets/images/login/userName.png" alt="" />
          </div>
          <input
            type="text"
            maxlength="11"
            oninput="this.value=this.value.replace(/[^\d]/g,'')"
            v-model.trim="mobileNumber"
            class="loginControl"
            autocomplete="off"
            placeholder="请输入登录手机号"
          />
        </div>
<!--        <div class="loginGroup">-->
<!--          <div class="loginIcon">-->
<!--            <img src="../../assets/images/login/pwd.png" alt="" />-->
<!--          </div>-->
<!--          <input-->
<!--            type="text"-->
<!--            v-model.trim="picCode"-->
<!--            class="loginControl"-->
<!--            autocomplete="off"-->
<!--            placeholder="请输入图片验证码">-->
<!--          <div class="loginAuthCode" @click="getImgCode">-->
<!--            <img :src="imgCodeSrc" alt="">-->
<!--          </div>-->
<!--        </div>-->
        <div class="loginGroup">
          <div class="loginIcon">
            <img src="../../assets/images/login/pwd.png" alt="" />
          </div>
          <input
            type="text"
            maxlength="6"
            oninput="this.value=this.value.replace(/[^\d]/g,'')"
            v-model.trim="code"
            class="loginControl"
            autocomplete="off"
            :placeholder="
              `${$t('Common.PleaseEnter')}${$t(
                'LoginModule.SMSVerificationCode'
              )}`
            "
          />
          <Button
            type="primary"
            v-if="codeStatus"
            class="codeBtn"
            @click="beforeSendCode"
            >{{ $t('LoginModule.GetCode') }}</Button
          >
          <button type="default" v-else class="codeBtnDisable" disabled>
            {{ codeText }}{{ $t('LoginModule.Resend') }}
          </button>
        </div>
        <div class="form-group">
          <input
            type="button"
            :value="`${$t('LoginModule.Login')}`"
            class="loginBtn"
            @click="login"
          />
        </div>
      </form>
      <Verify
        @success="checkSuccess"
        mode="pop"
        captchaType="blockPuzzle"
        :imgSize="{ width: '330px', height: '155px' }"
        ref="verify"
      />
    </div>
    <Modal
      v-model="selectSystemModalStatus"
      title="选择哪个系统登录"
      class="createModalClass"
    >
      <selectedSystemVue
        :canLoginSystemList="canLoginsystemList"
        @didClickCell="didClickCell"
      ></selectedSystemVue>
      <template #footer>
        <div style="height: 0px;"></div>
      </template>
    </Modal>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import ykRule, { validate } from '../../assets/js/ykRule';
import { mapActions, mapMutations } from 'vuex';
import Verify from '@/components/verifition/Verify.vue';
import selectedSystemVue from './selectedSystem.vue';
import { loginByVerifyApi, sendSmsCodeByVerifyApi } from '@/api/login';

const getAuthCodeUrl = '/v1/public/sendLoginSmsCode';
const loginUrl = '/v1/public/login';
const imgCodeUrl = '/v1/public/picCaptcha'; // 图片验证码
// 获取可以登录的应用
const getCanLoginAppsURL = '/v1/userInfo/canLoginApps';
let systemLan = 'en-US';
const navigatorLan = navigator.language; // 获取浏览器的语言设置
if (navigatorLan.indexOf('zh') == 0) {
  systemLan = 'zh-CN'; // 汉语默认设置成中文简体
}
if (localStorage.getItem('locale')) {
  systemLan = localStorage.getItem('locale');
}
export default {
  name: 'login',
  components: {
    selectedSystemVue,
    Verify
  },
  computed: {
    canLoginAppList() {
      return this.$store.state.canLoginAppList;
    },
    eyeType () {
      return this.isPassword ? 'md-eye-off' : 'md-eye';
    }
  },
  data() {
    return {
      isPassword: true,
      // 可登录系统列表
      canLoginsystemList: [],
      // 选择的系统的url
      systemSeletdID: '',
      // 弹窗装填
      selectSystemModalStatus: false,
      localeLanguage: systemLan === 'en-US' ? 'EN-US' : '中文',
      showErrorMessage: false,
      ErrorMessage: '',
      mobileNumber: '', // 用户手机号
      code: '', // 手机验证码
      codeText: 60,
      codeStatus: true, // 是否可以获取验证码
      timer: null,
      loginStatus: true // 防止二次提交
      // imgCodeSrc: '', // 图片验证码地址
      // picCode: '', // 图片验证码code
      // uuid: '' // 图形验证码uuid
    };
  },
  beforeDestroy() {
    clearInterval(this.timer); // 清空timmer
  },
  methods: {
    ...mapMutations('permission', ['ADD_ROUTERS']),
    ...mapActions(['getCanLoginAppList']),
    didClickCell(cell) {
      let url = '';
      this.canLoginsystemList.forEach(element => {
        if (element.id == cell.value) {
          url = element.appUrl;
        }
      });
      window.location.href = url;
    },
    // 发送验证码
    // sendCode() {
    //   this.showErrorMessage = false;
    //   if (!this.mobileNumber) {
    //     this.showErrorMessage = true;
    //     this.ErrorMessage = `${this.$t('Common.PleaseEnter')}${this.$t(
    //       'LoginModule.MobileNumber'
    //     )}`;
    //     return false;
    //   }
    //   // 手机号检验
    //   ykRule.testPhone('', this.mobileNumber, result => {
    //     if (result != null && result != undefined) {
    //       // this.$Message.error(result.message);
    //       this.ErrorMessage = result.message;
    //       return false;
    //     }
    //   });
    //   const params = {
    //     mobile: this.mobileNumber
    //     // picCode: this.picCode,
    //     // uuid: this.uuid
    //   };
    //   this.$ajax.post(getAuthCodeUrl, params).then(res => {
    //     const { data, code, msg } = res.data;
    //     if (code == 200) {
    //       // 获取成功倒计时
    //       this.countDown(); // 倒计时
    //       // 清空验证码输入框
    //       // this.picCode = '';
    //       // 刷新图片验证码
    //       // this.getImgCode();
    //     } else {
    //       this.showErrorMessage = true;
    //       this.ErrorMessage = msg;
    //     }
    //   });
    // },
    // 倒计时
    countDown() {
      this.codeStatus = false;
      this.codeText = 60;
      this.timer = window.setInterval(() => {
        if (this.codeText > 1) {
          this.codeText--;
        } else {
          window.clearInterval(this.timer); // 恢复按钮发送验证码先清除timer
          this.codeStatus = true;
        }
      }, 1000);
    },
    // 登录
    login() {
      this.showErrorMessage = false;
      if (!this.mobileNumber) {
        this.showErrorMessage = true;
        this.ErrorMessage = `${this.$t('Common.PleaseEnter')}${this.$t(
          'LoginModule.MobileNumber'
        )}`;
        return false;
      }
      // 手机号检验
      if (!validate.mobilePhone(this.mobileNumber)) {
        this.showErrorMessage = true;
        this.ErrorMessage = '手机格式错误';
        return;
      }
      if (!this.code) {
        this.showErrorMessage = true;
        this.ErrorMessage = `${this.$t('Common.PleaseEnter')}${this.$t(
          'LoginModule.SMSVerificationCode'
        )}`;
        return false;
      }
      // 校验验证码是纯数字
      const allNum = /^(\d+)(\.\d+)?$/.test(this.code);
      if (!allNum) {
        this.showErrorMessage = true;
        this.ErrorMessage = `${this.$t('Common.PleaseEnter')}正确的${this.$t(
          'LoginModule.SMSVerificationCode'
        )}`;
        return false;
      }
      const self = this;
      const params = {
        mobile: self.mobileNumber,
        smsCode: self.code
      };
      if (!self.loginStatus) {
        return;
      }
      self.loginStatus = false;
      loginByVerifyApi(params)
        .then(res => {
          self.loginStatus = true;
          const { data } = res;
          if (data.code === 200) {
            const { token } = data.data;
            localStorage.setItem('userInfo', JSON.stringify(data.data));
            Cookies.set('Admin-token', token, {
              domain: process.env.VUE_APP_TOKEN_DOMAIN,
              expires: 30
            });
            this.getCanLoginAppList().then(res => {
              if (res.msg == 'success') {
                this.canLoginsystemList = res['list'];
                if (
                  this.canLoginsystemList == null ||
                  this.canLoginsystemList.length == 0
                ) {
                  this.$Message.error('没有权限');
                } else if (this.canLoginsystemList.length > 1) {
                  if (
                    this.$route.query != undefined &&
                    this.$route.query.appId != undefined
                  ) {
                    this.canLoginsystemList.forEach(element => {
                      if (element.id == this.$route.query.appId) {
                        window.location.href = element.appUrl;
                      }
                    });
                    return;
                  }
                  self.selectSystemModalStatus = true;
                  this.canLoginsystemList.forEach(element => {
                    element.label = element.appName;
                    element.value = element.id;
                  });
                } else {
                  const obj = this.canLoginsystemList[0];
                  window.location.href = obj.appUrl;
                }
              }
            });
          } else {
            self.showErrorMessage = true;
            self.ErrorMessage = data.msg;
          }
        })
        .finally(() => {
          window.setTimeout(() => {
            this.loginStatus = true;
          }, 1000);
        });
    },
    beforeSendCode () {
      this.showErrorMessage = false;
      // 如果手机号不正确
      if (!validate.mobilePhone(this.mobileNumber)) {
        this.showErrorMessage = true;
        this.ErrorMessage = '手机格式错误';
        return;
      }
      // 展示拖拽二维码
      this.$refs.verify.show();
    },
    checkSuccess (params) {
      const data = {
        captchaVerification: params.captchaVerification,
        mobile: this.mobileNumber
      };
      sendSmsCodeByVerifyApi(data).then(res => {
        const { code, msg } = res.data;
        if (code === 200) {
          // 获取成功倒计时
          this.countDown(); // 倒计时
        } else {
          this.showErrorMessage = true;
          this.errorMessage = msg;
        }
      });
    }
    // 获取图形验证码
    // getImgCode() {
    //   this.$ajax.get(imgCodeUrl).then(res => {
    //     const { code, data } = res.data;
    //     if (code == 200) {
    //       const prefix = 'data:image/gif;base64,';
    //       this.imgCodeSrc = prefix + data.img;
    //       this.uuid = data.uuid;
    //     }
    //   });
    // }
  },
  mounted () {
    // this.getImgCode();
  }
};
</script>

<style lang="less">
html {
  overflow: auto !important;
}
.loginBox {
  background: url('../../assets/images/login/loginBg.jpg') no-repeat center;
  background-size: 100% 100%;
  background-color: #e6e6e6;
  padding-top: 40px;
  width: 100%;
  height: 100%;
  min-height: 660px;
  position: absolute;
  font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑';
}

.loginTitle {
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
  line-height: 80px;
  font-style: normal;
  font-size: 52px;
  color: #1c4cff;
  text-align: center;
}

.loginFormTitle {
  font-size: 29px;
  color: #000000;
  font-style: normal;
  text-align: center;
  margin-bottom: 40px;
  letter-spacing: 4px;
}
.loginMain {
  width: 900px;
  height: 480px;
  /* border-radius:5px; */
  /* box-shadow:0px 10px 20px #bfc5da; */
  margin: 0 auto;
  margin-top: 40px;
  /* background:#fff */
}
.loginLeft {
  float: left;
  background: #e0e0e0;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  padding: 130px 61px;
  height: 481px;
  box-sizing: border-box;
}
.loginLeft img {
  display: block;
  width: 328px;
}
.loginForm {
  float: right;
  position: relative;
  /* margin: 80px auto; */
  width: 450px;
  height: 481px;
  padding: 50px 25px;
  text-align: center;
  background: #fff;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.loginGroup {
  margin: 20px;
  padding: 10px 5px;
  border-bottom: 1px solid #1c4cff;
  text-align: left;
  position: relative;
}
.loginIcon {
  position: absolute;
  width: 30px;
  height: 30px;
  text-align: center;
}
.eyes {
  position: absolute;
  width: 30px;
  height: 30px;
  top: 10px;
  right: 5px;
  font-size: 30px;
  line-height: 30px;
  color: #1c4cff;
}
.sysCell {
  height: 50px;
  line-height: 50px;
}
.loginControl {
  border: none;
  outline: none;
  margin-left: 40px;
  font-size: 20px;
  line-height: 30px;
  vertical-align: middle;
  width: 260px;
}
.showMsg {
  position: absolute;
  font-size: 12px;
  color: #fff;
  text-align: center;
  line-height: 20px;
  width: 100%;
  color: red;
  left: 0;
  top: 100px;
}

.loginBtn {
  display: block;
  width: 168px;
  line-height: 48px;
  border-radius: 24px;
  text-align: center;
  background: #2d5afc;
  color: #fff;
  border: none;
  outline: none;
  margin: 50px auto;
  font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑';
  cursor: pointer;
  font-size: 18px;
}
.langLink {
  color: #1c4cff;
  font-size: 14px;
}
.codeBtn {
  position: absolute;
  right: 0;
  font-size: 14px;
  background-color: #2d5afc;
}

.codeBtnDisable {
  width: 90px;
  text-align: center;
  position: absolute;
  right: 0;
  height: 30px;
  border-radius: 3px;
  border: 1px solid #ccc;
  color: #ccc;
}
.loginAuthCode {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 90px;
  height: 30px;
}
.loginAuthCode img {
  width: 100%;
  height: 100%;
}
.clearfix {
  zoom: 1;
}
.clearfix:after {
  clear: both;
  display: block;
  content: '.';
  height: 0;
  visibility: hidden;
}
.operatePassword {
  text-align: end;
}
.operatePasswordA {
  padding-right: 15px;
}
.createModalClass .ivu-modal-content .ivu-modal-footer {
  padding: 0 !important;
}
.createModalClass .ivu-modal-content {
  .ivu-modal-body {
    padding: 0 16px;
  }
}
</style>
